export default (state = '', action) => {
    switch (action.type) {
        case 'BASE_PATH_NAME':
            return action.payload;
        default:
            return state;
    }
};
